import { render, staticRenderFns } from "./ModifyBinScore.vue?vue&type=template&id=e4daf8f4&"
import script from "./ModifyBinScore.vue?vue&type=script&lang=js&"
export * from "./ModifyBinScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports